module.exports = __webpack_public_path__ + "static/img/Keweenaw-Bay-small.d01da6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/Keweenaw-Bay-small.jpg
// module id = V1p1
// module chunks = 1